export default __webpack_public_path__ + "static/media/dynamic_website.ac45f07e.png";